// Copy for the "We connect Fiji to the world" map section (8 languages).
// Country names stay in English (proper nouns), consistent with Fiji/Nadi/Suva.
export const world = {
  en: {
    overline: "Global reach",
    title: "We connect Fiji to the world.",
    sub: "From the Americas to Asia, the Gulf and across the Pacific — we bring international investors and Fiji together, coordinating every step across time zones so distance is never the obstacle.",
    hub: "Fiji · Nadi & Suva",
    markets: "Investors we've guided reach Fiji from",
  },
  zh: {
    overline: "全球连接",
    title: "我们让斐济连接世界。",
    sub: "从美洲到亚洲、海湾地区乃至整个太平洋——我们把国际投资者与斐济连接起来，跨越时区协调每一个环节，让距离不再成为障碍。",
    hub: "斐济 · 楠迪与苏瓦",
    markets: "我们服务的投资者来自",
  },
  hi: {
    overline: "वैश्विक पहुँच",
    title: "हम फिजी को दुनिया से जोड़ते हैं।",
    sub: "अमेरिका से एशिया, खाड़ी क्षेत्र और पूरे प्रशांत तक — हम अंतरराष्ट्रीय निवेशकों और फिजी को एक साथ लाते हैं, समय-क्षेत्रों में हर कदम का समन्वय करते हुए ताकि दूरी कभी बाधा न बने।",
    hub: "फिजी · नाडी और सुवा",
    markets: "हमारे मार्गदर्शन में निवेशक यहाँ से आते हैं",
  },
  ja: {
    overline: "グローバルな接点",
    title: "私たちはフィジーを世界とつなぎます。",
    sub: "南北アメリカからアジア、湾岸、そして太平洋全域まで — 国際投資家とフィジーを結び、時差を越えてすべての手続きを調整し、距離を障害にしません。",
    hub: "フィジー · ナンディ＆スバ",
    markets: "私たちが支援した投資家の出身地",
  },
  ko: {
    overline: "글로벌 연결",
    title: "우리는 피지를 세계와 연결합니다.",
    sub: "아메리카에서 아시아, 걸프, 태평양 전역까지 — 국제 투자자와 피지를 연결하고 시차를 넘어 모든 단계를 조율하여 거리가 걸림돌이 되지 않게 합니다.",
    hub: "피지 · 난디 & 수바",
    markets: "우리가 안내한 투자자들의 출발지",
  },
  es: {
    overline: "Alcance global",
    title: "Conectamos Fiyi con el mundo.",
    sub: "Desde América hasta Asia, el Golfo y todo el Pacífico: unimos a inversores internacionales con Fiyi, coordinando cada paso entre husos horarios para que la distancia nunca sea un obstáculo.",
    hub: "Fiyi · Nadi y Suva",
    markets: "Los inversores que guiamos llegan a Fiyi desde",
  },
  fr: {
    overline: "Portée mondiale",
    title: "Nous relions Fidji au monde.",
    sub: "Des Amériques à l'Asie, au Golfe et à travers le Pacifique — nous rapprochons les investisseurs internationaux et Fidji, coordonnant chaque étape entre fuseaux horaires pour que la distance ne soit jamais un obstacle.",
    hub: "Fidji · Nadi et Suva",
    markets: "Les investisseurs que nous accompagnons rejoignent Fidji depuis",
  },
  ar: {
    overline: "حضور عالمي",
    title: "نربط فيجي بالعالم.",
    sub: "من الأمريكتين إلى آسيا والخليج وعبر المحيط الهادئ — نجمع المستثمرين الدوليين وفيجي معًا، وننسّق كل خطوة عبر المناطق الزمنية حتى لا تكون المسافة عائقًا أبدًا.",
    hub: "فيجي · نادي وسوفا",
    markets: "المستثمرون الذين أرشدناهم يصلون إلى فيجي من",
  },
};
